export class LoginVo{
    email:any;
    password:any;
}